const EVENT_SERVICE_BASE = "/gateway/api/event-service"

export const API_ADD_ENTERPRISE = `${EVENT_SERVICE_BASE}/business`
export const API_GET_LIST_ENTERPRISE = `${EVENT_SERVICE_BASE}/business`
export const API_GET_INFO_ENTERPRISE = `${EVENT_SERVICE_BASE}/business`
export const API_CHANGE_ENTERPRISE = `${EVENT_SERVICE_BASE}/business`
export const API_GET_NAME_ENTERPRISE = `${EVENT_SERVICE_BASE}/business`
